module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "h10"
  }, [_c('a', {
    attrs: {
      "id": "a30"
    }
  }), _vm._v("Chapter 3: Big Things from Little Things Grow")]), _vm._v(" "), _c('p', {
    staticClass: "p5"
  }, [_c('span', {
    staticClass: "t2"
  }, [_vm._v("St. Michael’s Rectory, Night")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Leslie tried his best but couldn’t get back to sleep. The narrow bed, the darkness around him, and the bit of light from an outdoor streetlamp lighting the fluorescent crucifix on the wall, giving it a yellowish glow, made him reflect on the orphanage and the large dormitory he and Robert had shared with other parentless boys. He inventoried his thoughts and realized he’d forgotten more that he remembered of those days.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Times had been hard, but they had each other. Robert was five years older, taller, bigger, and Leslie’s self-proclaimed protector. At eighteen, Robert went off to seminary and then everything changed; those were the days, weeks, months, and years he can’t bring to mind.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("He told himself to switch gears, think more happy thoughts.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Edward.")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("The sudden thought of his lover brought Leslie back to the present.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("He was wide-awake, and horny on top of it. Leslie let his right hand drift down beneath the sheets and slip inside his undershorts.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_c('span', {
    staticClass: "t6"
  }, [_vm._v("Edward. Edward. Double goddamn you for running off and leaving me again!")])]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("He’d tried to be adult about it, soldier on as Edward had pressed him to do, but that last night they spent together in their bedroom at Cherries Cottage, he was already feeling the pain of Edward’s imminent departure in the morning. In some ways, with his mind half on a new government assignment and the other on his travel plans, Edward had already gone from Leslie, mentally if not physically.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Why is it the damn pants always come off first?” Leslie had said after Edward shut the door, pushed him back on the bed, and began to undress himself.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Hm. Never gave it much thought.” Edward stripped off his shirt and tossed it on a chair. Leslie sat up and began to work on getting his shoes off. “Come on love, we haven’t much time. I leave at dawn.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“You all do,” Leslie said. “I know why Caroline’s going. She can’t stand another year of playing mother—”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("He stopped short before saying more he’d regret later. Caroline was over the moon about Max, now two years old and literally into everything not nailed down. He was the joy of her life, along with her husband, Cyril. Still, something was missing: She desperately missed her government work.")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I’m not cut out to be a stay at home housewife,” she had told him. “I have more to offer and want to get back in action.” She pinched his cheek and then kissed it. “We’re used to accepting our orders and being out there doing our bit. There, you have it. Do you think badly of me?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Leslie told her he very much did. “You’re a stinker, running off and leaving me here on my own. I thought we were soul mates. And what about your child? What about Max? I can’t take care of him.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Course not. I’ve already had a conversation with Mrs. Jenkins. She and Sam and Ilsa are happy to mind him. It’s only for a short while. She’s done it before and I trust her completely. You’ll be around to check up on how he’s doing. Max adores you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("He opened his mouth to speak but she cut him off. “Nothing for you to worry about. We’ll all be home in two ticks and back together with our little family. You’ll see.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("He sighed wearily and ran a hand through his thinning hair. “Yes, you’ll all be home safe and sound, but what about me, goddamn it?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“You’re such a child, Les.” It was then she had wrapped her arms around him and gave him a tight hug. “It’s something I need to do. For myself. You say it’s selfish, and I admit it is. But that’s that. End of conversation.”")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Edward had slid beneath the covers and waited for Leslie to finish undressing. “Will it be anytime this year?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“What?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Stop woolgathering. Get your arse over here and into bed. We have so little time before morning and I want to spend it in your arms. Let’s don’t waste it.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I heard you get the call tonight,” Leslie said. “I knew what it was. First Caroline and Cyril. Now you. And what about me in all this?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“God, you’re a baby.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Caroline said as much. It’s true. I hate being alone. Again.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I ‘spect you’ll soldier on. You’ll be here when I return. I have no doubt.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“God, I hate those two words. Soldier on.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Listen, this one has all the signs of being a quick in and out sort of thing.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Soldier on,” Leslie repeated. He kicked off his shoes with rather more vigor than intended and barely missed hitting a small ornament on their chest of drawers: a ceramic of two small boys holding hands, something Caroline had picked up in a London shop for their “marriage.” The best she could do, she’d said, since they had been pressed for time.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Get the lead out, will you?” Edward said in a commanding manner.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I’m coming,” Leslie said, loosening his tie, hanging it on the doorknob.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I certainly hope so.” Edward laughed as he watched his lover run through a very s-l-o-w striptease.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Howja like being ‘married’ so far?” Leslie asked. “I mean, as married as we can be in these days and times under the cover of secrecy.” He was now down to his undershorts.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Under the cover of something. Get in here! Enough fooling around out there. Let’s fool around in here.” Edward moved over, lifted up the blankets. “Get in, for chrissakes.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Your wish is my commandment.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“You mean command,” Edward said, correcting him. “Commandment’s another thing. We’ll surely be breaking one or two of those in a moment.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Leslie crossed his hands over his bare chest. “I’m waiting for an answer to my question. Marriage. What do you think of it now, two years post our secret ceremony in the garden?” He went to switch off the bedside lamp.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Edward told him not to. “I want to look at you.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Now that’s nice. Can I have more talk like that, please?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Back to the marriage question first. I think it’s just ducky. Now get into this bed before I have to—”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Leslie took a leap and threw himself on his lover.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Now that’s more like it.” Edward wrapped his arms around Leslie’s waist, his hands firmly on Leslie’s buttocks.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“You’re going to flip me, aren’t you?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Just you wait.”")]), _vm._v(" "), _c('p', {
    staticClass: "p3"
  }, [_vm._v("* * * *")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Later, satisfied from the usual frantic lovemaking that normally preceded his departure, Edward ran a hand down his lover’s thigh and rested it there. “Mm. Like that.” Then he kissed Leslie softly on the lips. “What was I supposed to answer?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Oh, that.” Leslie snuggled closer. “You’re in love with me now as you were then, even more so. Or something like that.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I am.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“You are what?” Leslie asked.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“You know what I mean.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Then say it.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“You’re not letting me off easy, are you?” Edward looked up at the ceiling as if trying to think of the right words and arrange them in proper order.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Not a chance.” Leslie knew that look. He’d seen it before and thought it a sign Edward was ready to tell him a whopper.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Let me see. I’m in love with you, more so than I’ve ever been with any man. How’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Not good enough.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“I’m in love with you as I was back then before our garden ceremony.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Uh-uh.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Nasty little bugger, aren’t you?” Edward steepled his fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Absolutely,” Leslie said, “and loving every second of it. Go on. You know what to say.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Edward closed his eyes, then let out a loud, snuffling snore.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Leslie smacked him playfully on the cheek.")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“All right. I’m in love with you "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("now")]), _vm._v(" more than I was back then or ever have been with any other man,” Edward said breathlessly. “Happy?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“In heaven.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“We have time for another. Are you game?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("Leslie reached under the covers and felt Edward’s sex begin to expand in his hand. “My, it "), _c('span', {
    staticClass: "t6"
  }, [_vm._v("is")]), _vm._v(" true what they say.”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“What’s that?”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Big things from little things grow. I’m probably misquoting as I’m wont to do but—”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Little? Why, I’ll have you know—”")]), _vm._v(" "), _c('p', {
    staticClass: "p2"
  }, [_vm._v("“Shut up, Lochinvar, time’s a wastin’.”")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0cd5015e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/007.vue
// module id = 72
// module chunks = 0